import React from 'react';
import clsx from 'clsx';
import styles from './index.scss';
import GoogleIcon from './google-logo.svg';

export default function Button(props) {
  const { className, disabled, onClick, text } = props;
  // Render button
  return (
    <div
      className={clsx(
        className,
        'google-button',
        disabled && 'disabled',
        styles.button,
        disabled && styles.disabled
      )}
      onClick={(event) => !disabled && onClick?.(event)}
    >
      <div>
        <img className="google-button-icon" alt="" src={GoogleIcon} />
      </div>
      <div className="google-button-label">{text}</div>
    </div>
  );
}
